export const getSupportedConverterFileTypes = () => [
    ".jpeg",
    ".png",
    ".webp",
    ".blp",
    ".bmp",
    ".jpg",
    ".heic",
    ".heif",
  ];
  export const getPhotoMaxSize = () => 1024 * 1024 * 5;
  export const assetAllowedFileTypes = () => [".jpeg", ".png", ".webp", ".blp", ".bmp",".jpg",".mp4", ".mov",".svg",".mp3"];
  export const getVideoMaxSize = () => 1024 * 1024 * 500;